import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Navbar } from "@/components/landing/Navbar";
import { Hero } from "@/components/landing/Hero";
import { CustomerProblem } from "@/components/landing/CustomerProblem";
import { CustomerBenefits } from "@/components/landing/CustomerBenefits";
import { SystemArchitecture } from "@/components/landing/SystemArchitecture";
import { EnergyDiagram } from "@/components/landing/EnergyDiagram";
import { ProductPlatform } from "@/components/landing/ProductPlatform";
import { Verticals } from "@/components/landing/Verticals";
import { Economics } from "@/components/landing/Economics";
import { CompetitiveMatrix } from "@/components/landing/CompetitiveMatrix";
import { PilotProgram } from "@/components/landing/PilotProgram";
import { PhotographicPause } from "@/components/landing/PhotographicPause";
import { About } from "@/components/landing/About";
import { ContactSection } from "@/components/landing/ContactSection";
import { Footer } from "@/components/landing/Footer";
import { scrollToSection } from "@/lib/scrollTo";

export default function LandingPage() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const timer = setTimeout(() => scrollToSection(location.hash), 400);
      return () => clearTimeout(timer);
    }
  }, [location.hash]);

  return (
    <div data-testid="landing-page" className="bg-baseLight min-h-screen">
      <Navbar />
      <Hero />
      <CustomerProblem />
      <CustomerBenefits />
      <SystemArchitecture />
      <EnergyDiagram />
      <PhotographicPause />
      <ProductPlatform />
      <Verticals />
      <Economics />
      <CompetitiveMatrix />
      <PilotProgram />
      <About />
      <ContactSection />
      <Footer />
    </div>
  );
}
